shadow$provide[454] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec2 vUV;

void setRawUV(vec4 xyzw) {
  vUV = xyzw.xy;
}
`;

};